import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useLinkTreeFormActions } from './_form/LinkTreeFormHandler'
import { useSaveLinkTree } from './_request/saveLinkTreeItems'
import Button from '../../../packages/kiti/components/actions/Button'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Link from '../../../packages/kiti/components/actions/Link'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import Text from '../../../packages/kiti/components/presentation/Text'

const FooterBar = () => {
  const { t } = useTranslation('editLinkTreeItems')
  const [save, { loading, error, validation }] = useSaveLinkTree()
  const { addNewLinkTreeItem } = useLinkTreeFormActions()

  return (
    <>
      <FlexGrid justify="space-between" gutter={0.2}>
        <Link block onClick={addNewLinkTreeItem}>
          <IconText iconLeft="BsPlusCircle" label={t('addNewLink')} color={COLORS.purple} />
        </Link>

        {!!error && <Text color={COLORS.red}>{error.message}</Text>}
        {!!validation && <Text color={COLORS.red}>{validation}</Text>}
        <FlexCol alignSelf="flex-end">
          <Button loading={loading} onClick={save}>
            {t('save')}
          </Button>
        </FlexCol>
      </FlexGrid>
      <Separator weight={4} />
      <FlexGrid justify="space-between" gutter={0.2}></FlexGrid>
    </>
  )
}

export default FooterBar
